import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReturnIcon from "../../../assets/icons/back_page.svg";
import { TextsProps } from "../../../database/txt.interface";
import { AppActions } from "../../../store/ducks/app";
import { FinancialActions } from "../../../store/ducks/financial";


import { Colors } from "../../../styles/colors";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import { ContainerDash, Icon, Return } from "../../../styles/global";
import { H2Desk, P2Desk, P3Desk } from "../../../styles/styles_text";
import { Content, Content2 } from "../Pagamentos/styles";
import { UserProps } from "../../../interfaces/pacientes.interface";


const PagamentosExternal: React.FC = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;

	const config_servicos: { SERVICO_IUGU: string | number, SERVICO_SUPERLOGICA: string | number, SERVICO_HUB: string | number } =
		useSelector((state: any) => state.configs.config_servicos);

	const user_logado: UserProps = useSelector((state: any) => state.auth.user);

	const downloadFile = (url: string, filename: string) => {
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			if (event.origin !== "https://financeiro.kinology.com.br") return;

			if (event.data.type === "BOTAO_PRESSIONADO") {
				console.log("Botão no iframe foi clicado!", event.data.payload);
				downloadFile(event.data.payload.url, "boleto")
			}
		};

		window.addEventListener("message", handleMessage);

		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, []);


	return (
		<ContainerDash style={{ backgroundColor: 'white' }}>
			<Content2 style={{ backgroundColor: 'white' }}>
				<Return
					style={{ marginLeft: '2rem' }}
					onClick={() => {
						if (inadimplencia_motivo) {
							dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo))
						} else {
							dispatch(DashBoardActions.set_current_page("minha_conta"));
							dispatch(
								AppActions.set_option_menu(
									false,
									current_language?.menu_lateral_minha_conta
								)
							);
						}
					}}
				>
					<Icon
						src={ReturnIcon}
						style={{ width: "0.875rem", height: "0.875rem" }}
					/>
					<P3Desk style={{ color: Colors?.primary_blue_k_main, marginLeft: '0.5rem' }}>
						{current_language?.menu_lateral_minha_conta}
					</P3Desk>
				</Return>
				<div style={{ width: "100%", height: "80vh" }}>
					<iframe
						src={`https://financeiro.kinology.com.br/?hb=${config_servicos.SERVICO_HUB}&sp=${config_servicos.SERVICO_SUPERLOGICA}&user=${user_logado.ID_USUARIO}&el=false&jwt=${user_logado.token}`}
						style={{ width: "100%", height: "80vh", border: "none" }}
						title="Minha WebView"
					/>
				</div>	
			</Content2>
		</ContainerDash>
	);
};



export default PagamentosExternal;
